import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import axios from 'axios';
import callAPI from '../axios-api';

import store from '../store';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    components: {
      default: () => import('../views/HomeView.vue'),
    },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: 'black' },
    },
  },
  {
    path: '/about/',
    name: 'about',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  {
    path: '/events/',
    name: 'Events',
    component: () => import('../views/Events.vue'),
  },
  {
    path: '/events/:slug_category/:slug_event/',
    name: 'Event',
    component: () => import('../views/SingleEvent.vue'),
  },
  {
    path: '/venues',
    name: 'Venues',
    component: () => import('../views/Venues.vue'),
  },
  {
    path: '/venues/:slug_category/:slug_venue/',
    name: 'VenueDetail',
    component: () => import('../views/VenueDetail.vue'),
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/CartView.vue'),
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('../views/CheckoutView.vue'),
  },
  {
    path: '/payment/',
    name: 'Payment',
    component: () => import('../views/Payment.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/register/',
    name: 'Signup',
    component: () => import('../views/Signup.vue'),
  },
  {
    path: '/password-reset/',
    name: 'PasswordReset',
    component: () => import('../views/ResetPassword.vue'),
  },
  {
    path: '/password-reset/confirm/',
    name: 'PasswordResetConfirm',
    component: () => import('../views/PasswordResetConfirm.vue'),
  },
  {
    path: '/account/profile/',
    name: 'Account',
    component: () => import('../views/Account.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/orders/',
    name: 'Orders',
    component: () => import('../views/Orders.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/tickets/',
    name: 'Tickets',
    component: () => import('../views/Tickets.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/notifications/',
    name: 'AccountNotifications',
    component: () => import('../views/AccountNotifications.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/dashboard/',
    name: 'Dashboard',
    component: () => import('../views/MerchantViews/MerchantDashboard.vue'),
    meta: {
      requiresMerchantProfile: true,
      requiresAuth: true,
    },
  },
  {
    path: '/account/dashboard/events/',
    name: 'MerchantEvents',
    component: () => import('../views/MerchantViews/MerchantEvents.vue'),
    meta: {
      requiresMerchantProfile: true,
      requiresAuth: true,
    },
  },
  {
    path: '/account/dashboard/orders/',
    name: 'merchantorders',
    component: () => import('../views/MerchantViews/MerchantOrders.vue'),
    meta: {
      requiresMerchantProfile: true,
      requiresAuth: true,
    },
  },
  {
    path: '/account/dashboard/reps/',
    name: 'MerchantReps',
    component: () => import('../views/MerchantViews/MerchantReps.vue'),
    meta: {
      requiresMerchantProfile: true,
      requiresAuth: true,
    },
  },
  {
    path: '/account/dashboard/scanner/',
    name: 'TicketScanner',
    component: () => import('../views/TicketScanner.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/rep-dashboard/',
    name: 'RepDashboard',
    component: () => import('../views/RepDashboard.vue'),
    meta: {
      requiresRepProfile: true,
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// router.js

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next('/login');
    } else if (to.meta.requiresMerchantProfile) {
      const getUserProfile = () => {
        if (!store.getters.isTokenExpired) {
          const token = store.state.token;
          const refreshToken = store.state.refresh_token;
          const baseURL = process.env.VUE_APP_API_URL;

          let userprofile = {};

          store.state.isLoading = true;
          callAPI
            .get('/api/v1/account/current/', {
              headers: {
                Authorization: `JWT ${token}`,
              },
            })
            .then((res) => {
              userprofile = res.data.profile;

              store.commit('setProfileType', res.data.profile.profile_type);
              store.state.isLoading = false;
              if (
                res.data.profile.profile_type === 'merchant' ||
                res.data.profile.profile_type === 'rep'
              ) {
                next();
              } else {
                next('/account/profile/');
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.status == 401) {
                store
                  .dispatch('reAuthorizeApi', refreshToken)
                  .then((res) => {
                    getUserProfile();
                  })
                  .catch((err) => {
                    console.log(err);
                    next('/account/profile');
                  });

                /* callAPI
                .post('/api/auth/refresh/', {
                  refresh: refreshToken,
                })
                .then((res) => {
                  const token = res.data.access;
                  const refreshToken = res.data.refresh;
                  //const userID = res.data.user.id;
                  this.$store.commit('setToken', { token, refreshToken });
                  console.log(res.data);
                  this.getUserProfile();
                })
                .catch((err) => {
                  console.log(err);
                }); */
              } else {
                console.log(err);
                next('/account/profile');
              }
            });
          store.state.isLoading = false;
        } else {
          store
            .dispatch('reAuthorizeApi', store.state.refresh_token)
            .then((res) => {
              getUserProfile();
            })
            .catch((err) => {
              console.log(err);
              next('/account/profile');
            });
        }
      };
      getUserProfile();
    } else if (to.meta.requiresRepProfile) {
      const getUserProfile = () => {
        if (!store.getters.isTokenExpired) {
          const token = store.state.token;
          const refreshToken = store.state.refresh_token;
          const baseURL = process.env.VUE_APP_API_URL;

          let userprofile = {};

          store.state.isLoading = true;
          callAPI
            .get('/api/v1/account/current/', {
              headers: {
                Authorization: `JWT ${token}`,
              },
            })
            .then((res) => {
              userprofile = res.data.profile;

              store.commit('setProfileType', res.data.profile.profile_type);
              store.state.isLoading = false;
              if (
                res.data.profile.profile_type === 'merchant' ||
                res.data.profile.profile_type === 'rep'
              ) {
                next();
              } else {
                next('/account/profile/');
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.status == 401) {
                store
                  .dispatch('reAuthorizeApi', refreshToken)
                  .then((res) => {
                    getUserProfile();
                  })
                  .catch((err) => {
                    console.log(err);
                    next('/account/profile');
                  });

                /* callAPI
                .post('/api/auth/refresh/', {
                  refresh: refreshToken,
                })
                .then((res) => {
                  const token = res.data.access;
                  const refreshToken = res.data.refresh;
                  //const userID = res.data.user.id;
                  this.$store.commit('setToken', { token, refreshToken });
                  console.log(res.data);
                  this.getUserProfile();
                })
                .catch((err) => {
                  console.log(err);
                }); */
              } else {
                console.log(err);
                next('/account/profile');
              }
            });
          store.state.isLoading = false;
        } else {
          store
            .dispatch('reAuthorizeApi', store.state.refresh_token)
            .then((res) => {
              getUserProfile();
            })
            .catch((err) => {
              console.log(err);
              next('/account/profile');
            });
        }
      };
      getUserProfile();
    } else {
      next();
      return;
    }
  } else {
    next();
  }
});

export default router;
